"use client"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTriangleExclamation } from "@instadeepai/fontawesome-pro-regular"

import { Card } from "@shared/ui"
import { useRouter } from "next/navigation"

export function ForgeFormError() {
  const router = useRouter()
  return (
    <Card className="flex h-[588px] w-[560px] flex-col gap-6 rounded-xl border p-8 transition-colors duration-200">
      <div className="flex flex-1 items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="rounded-full bg-yellow-100 px-4 py-3">
            <FontAwesomeIcon
              icon={faTriangleExclamation}
              className="text-lg text-yellow-600"
            />
          </div>
          <h3 className="text-lg font-semibold text-gray-900">
            Unable to Load Form
          </h3>
          <p className="text-center text-gray-600">
            We couldn&apos;t load the form configuration. This might be a
            temporary issue.
          </p>
          <button
            onClick={() => router.refresh()}
            className="rounded bg-blue-600 px-4 py-2 text-white transition-colors hover:bg-blue-700"
          >
            Try Again
          </button>
        </div>
      </div>
    </Card>
  )
}
